/**
 * Error text for a failed DoseSpot (e-Rx) API call.
 *
 * Vendor validation failures arrive as a structured `detail`
 * (`{ message, vendor, status_code, model_state, ... }`) whose `message` is
 * already sanitized server-side; plain errors arrive as a string `detail`.
 * Passing the object itself to `new Error()` rendered "[object Object]".
 */
export function doseSpotErrorMessage(data: unknown, fallback: string): string {
  const detail = (data as { detail?: unknown } | null | undefined)?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (detail && typeof detail === 'object') {
    const message = (detail as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim()) return message;
  }
  return fallback;
}
